
import { defineComponent, PropType } from 'vue'
import { iHierarchy } from '../../../HierarchyManagement'
import Calendar from 'primevue/calendar'
import Checkbox from 'primevue/checkbox'
import Card from 'primevue/card'

export default defineComponent({
    name: 'hierarchy-management-hierarchies-filter-card',
    components: { Calendar, Checkbox, Card },
    props: { selectedHierarchy: { type: Object as PropType<iHierarchy | null> } },
    emits: ['applyFilters'],
    data() {
        return {
            showMissingElements: false,
            expandFilterCard: false,
            afterDate: null as Date | null
        }
    },
    created() {},
    methods: {
        applyFilters() {
            this.$emit('applyFilters', { showMissingElements: this.showMissingElements, afterDate: this.afterDate })
        },
        resetFilters() {
            this.showMissingElements = false
            this.afterDate = null
            this.$emit('applyFilters', null)
        }
    }
})
